import { Component } from 'react';
import GMSGeometry from '../Helpers/GMSGeometry';

class MapsPoint extends Component {

    constructor(props) {
        super(props);
        this.marker = null;
        this.infoWindow = null;
        this.mapClickListerner = null;
        this.markerClickListener = null;
        this.isInfoWindowOpen = this.isInfoWindowOpen.bind(this);
        this.redraw = this.redraw.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentWillUnmount() {
        if ( this.marker !== null ) {
            this.marker.setMap(null);
        }
        if ( this.mapClickListerner !== null ) {
            window.google.maps.event.removeListener(this.mapClickListerner);
        }
        if ( this.markerClickListener !== null ) {
            window.google.maps.event.removeListener(this.markerClickListener);
        }
    }

    isInfoWindowOpen(){
        if ( this.infoWindow === null ) return false;
        var map = this.infoWindow.getMap();
        return map !== null;
    }

    redraw() {
        const { coord, isPlanMarker, currentPlan, setCurrentPlan, setSelectedShape, deleteShape, selectedShape, isDrawed, isEdited} = this.props;
        if ( window.mapRef === undefined || coord === undefined ) return;
        var markerIcon = '/Images/marker.png';

        var markerColor = '#FF4200'
        var strokeColor = '#FFFCE8'

        if(selectedShape!== null && selectedShape !== undefined  && selectedShape[0].coordsArray[0] === coord) {
            markerColor = 'orange'
            strokeColor = 'orange'
        } 

        if ( this.marker === null ) {
            this.marker = new window.google.maps.Marker({
                position: coord,
                map: window.mapRef,
                zIndex: 5,
                icon:{
                    path: window.google.maps.SymbolPath.CIRCLE,
                    fillColor:markerColor,
                    fillOpacity:0.5,
                    strokeColor:strokeColor,
                    strokeWeight:2,
                    scale: 6.5
                }
            });
        }
        else {
            this.marker.setPosition(coord);
            this.marker.setOptions({
                icon:{
                        path: window.google.maps.SymbolPath.CIRCLE,
                        fillColor:markerColor,
                        fillOpacity:0.5,
                        strokeColor:strokeColor,
                        strokeWeight:2,
                        scale: 6.5
                    }
            })
        }

        window.google.maps.event.clearInstanceListeners(this.marker)

        window.google.maps.event.addListener(this.marker,'click',function(e){
            if ( isPlanMarker ) return
            var obj = currentPlan.shapesArray.filter((obj)=>{
                return obj.coordsArray[0] === coord
            })
            setSelectedShape(obj)
        })

        if ( !isDrawed && !isEdited ){
            this.marker.setDraggable(false)
        }
        else if ( isDrawed || isEdited ){
            window.google.maps.event.addListener(this.marker,'rightclick',function(e){
                this.marker=null
                currentPlan.shapesArray = currentPlan.shapesArray.filter(function( obj ) {
                    if(obj.coordsArray[0] === coord){
                        deleteShape(obj)
                    }
                    return obj.coordsArray[0] !== coord
                })
                setSelectedShape(null)
                setCurrentPlan(currentPlan)
            })

            this.marker.setDraggable(true)
            this.marker.addListener('dragend', function(e){
                if( !isPlanMarker ){
                    var obj = currentPlan.shapesArray.filter((obj)=>{
                        return obj.coordsArray[0] === coord
                    })
    
                    if( obj.length !== 0 ){
                        obj[0].coordsArray[0] = {
                            lat:e.latLng.lat(),
                            lng:e.latLng.lng()
                        }
                    }
                }
                else{
                    currentPlan.markerCoord = {
                        lat:e.latLng.lat(),
                        lng:e.latLng.lng()
                    }                    
                }
                setCurrentPlan(currentPlan)
            })
        }

        if ( isPlanMarker === true ) {
            const title = GMSGeometry.latLngToUtmString(currentPlan.markerCoord)
            this.marker.setOptions({
                icon:markerIcon,
            })
            this.infoWindow = new window.google.maps.InfoWindow({
                content: '<p class="has-text-black-bis has-text-weight-normal">' + title + '</p>'
            });
            this.infoWindow.open(window.mapRef, this.marker);
        }
    }

    handleClick() {
        const self = this;
        const { isPlanMarker } = this.props;

        if ( this.marker === null ) return;
        if ( isPlanMarker === true && this.infoWindow !== null ) {
            this.mapClickListerner = window.mapRef.addListener('click', () => {
                this.infoWindow.close();
            });
            this.markerClickListener = this.marker.addListener('click', () => {
                if ( self.isInfoWindowOpen() ) {
                    this.infoWindow.close();
                }
                else {
                    this.infoWindow.open(window.mapRef, this.marker);
                }
            });
        }
    }

    render() {
        this.redraw()
        this.handleClick();
        return null;
    }

}

export default MapsPoint;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsPoint.js